import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  SurveyConfigurationCreatePayload,
  SurveyConfigurationResponse,
  SurveyConfigurationUpdatePayload,
  SurveyLinkResponse,
  SurveyParticipationPopupStatusResponse,
  SurveyParticipationResponse,
} from '../../models/admin/survey-configuration.model';
import { API_URLS } from '../../constants/api-urls/api-urls';
import { skipSpinnerOptions } from '../../core/services/http-options.utils';

@Injectable({
  providedIn: 'root'
})
export class SurveyConfigurationApiService {

  constructor(private http: HttpClient) { }

  getSurveyConfigurationList(): Observable<SurveyConfigurationResponse[]> {
    return this.http.get<SurveyConfigurationResponse[]>(API_URLS.ADMIN.SURVEY_CONFIGURATION.LIST, skipSpinnerOptions());
  }

  createSurveyConfigurations(payload: SurveyConfigurationCreatePayload): Observable<SurveyConfigurationResponse[]> {
    return this.http.post<SurveyConfigurationResponse[]>(API_URLS.ADMIN.SURVEY_CONFIGURATION.CREATE, payload, skipSpinnerOptions());
  }

  updateSurveyConfigurations(payload: SurveyConfigurationUpdatePayload): Observable<SurveyConfigurationResponse[]> {
    return this.http.patch<SurveyConfigurationResponse[]>(API_URLS.ADMIN.SURVEY_CONFIGURATION.UPDATE, payload, skipSpinnerOptions());
  }

  deleteSurveyConfiguration(survey_id: number, updated_by: number): Observable<SurveyConfigurationResponse> {
    const params = new HttpParams().set('updated_by', updated_by);
    return this.http.patch<SurveyConfigurationResponse>(API_URLS.ADMIN.SURVEY_CONFIGURATION.DELETE(survey_id), null, { ...skipSpinnerOptions(), params });
  }

  getSurveyLink(business_unit_code: string, region_code: string): Observable<SurveyLinkResponse> {
    const params = new HttpParams()
      .set('business_unit_code', business_unit_code)
      .set('region_code', region_code);
    return this.http.get<SurveyLinkResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.SURVEY_LINK, { ...skipSpinnerOptions(), params });
  }

  getSurveyParticipationPopupStatus(wwid: number, business_unit_code: string, region_code: string): Observable<SurveyParticipationPopupStatusResponse> {
    const params = new HttpParams()
      .set('business_unit_code', business_unit_code)
      .set('region_code', region_code);
    return this.http.get<SurveyParticipationPopupStatusResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.POPUP_STATUS(wwid), { ...skipSpinnerOptions(), params });
  }

  markParticipated(wwid: number, survey_id: number): Observable<SurveyParticipationResponse> {
    return this.http.post<SurveyParticipationResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.MARK_PARTICIPATED(wwid, survey_id), null, skipSpinnerOptions());
  }

  remindLater(wwid: number, survey_id: number): Observable<SurveyParticipationResponse> {
    return this.http.post<SurveyParticipationResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.REMIND_LATER(wwid, survey_id), null, skipSpinnerOptions());
  }

  remindTomorrow(wwid: number, survey_id: number): Observable<SurveyParticipationResponse> {
    return this.http.post<SurveyParticipationResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.REMIND_TOMORROW(wwid, survey_id), null, skipSpinnerOptions());
  }

  optOut(wwid: number, survey_id: number): Observable<SurveyParticipationResponse> {
    return this.http.post<SurveyParticipationResponse>(API_URLS.ADMIN.SURVEY_PARTICIPATION.OPT_OUT(wwid, survey_id), null, skipSpinnerOptions());
  }
}
